import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Handle redirect from 404.html page
const redirect = sessionStorage.getItem("redirect");
if (redirect) {
  sessionStorage.removeItem("redirect");
  window.history.replaceState(null, null, redirect);
}

// Dynamically update favicon based on environment variables
const updateFavicon = () => {
  const domain = process.env.REACT_APP_DOMAIN || "";
  if (domain) {
    const faviconElement = document.getElementById("favicon");
    const appleTouchIcon = document.getElementById("apple-touch-icon");

    if (faviconElement) {
      faviconElement.href = `${domain}/favicon.ico`;
    }

    if (appleTouchIcon) {
      appleTouchIcon.href = `${domain}/logo192.png`;
    }
  }
};

// Update favicon as soon as possible
updateFavicon();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
